// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"594":"32e14348","780":"4e622cfd"}[chunkId] + ".chunk.js";
};